import React from "react";
import {Tile} from "../";
import { Container, Row, Col } from "react-bootstrap";

export const Tiles = ({ topics, chapter }) => {
  return (
    <Container>
      <Row style={{ justifyContent: "center" }}>
        {topics && topics.length
          ? topics.map((topic, i) => {
              return (
                <Col xs="auto" key={topic.title + i} className="module-tile">
                  <Tile topic={topic} chapter={chapter ? chapter : undefined} />
                </Col>
              );
            })
          : null}
      </Row>
    </Container>
  );
};
